import { getExportUserList } from '@/services/userSettings';
export async function fetchExportData(fileType) {
    return getExportUserList(fileType, 'blob');
}
